module.exports = __webpack_public_path__ + "img/Nora-logoFooter.855505.png";